import { Component, h, Prop, Watch, Listen, Element } from '@stencil/core';

interface UiCmsSlideBody {
  anchorName: string;
}

@Component({
  tag: 'ui-cms-slide',
  styleUrl: 'ui-cms-slide.css',
  shadow: false,
})
export class UiCmsSlide {
  @Element() el: HTMLUiCmsSlideElement;

  @Prop({ mutable: true }) body: UiCmsSlideBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  @Listen('hashchange', { target: 'window' })
  onHashChange(e: HashChangeEvent): void {
    const { hash } = new URL(e.newURL);
    this.jumpToSlideWithAnchor(hash);
  }

  @Listen('uiSliderReady', { target: 'window' })
  onSliderReady(e: CustomEvent): void {
    if (this.el.closest('ui-cms-slider')?.body.uniqueId === e.detail.id) {
      this.jumpToSlideWithAnchor(window.location.hash);
    }
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  private jumpToSlideWithAnchor(hash: string): void {
    if (this.checkIfHashMatchesAnchor(hash)) {
      const slideIndex = parseInt(this.el.getAttribute('data-swiper-slide-index'), 10);
      const slider = this.el.closest('ui-slider');
      if (slideIndex >= 0) slider.jumpToSlide(slideIndex);
    }
  }

  private checkIfHashMatchesAnchor(hash: string): boolean {
    return this.body.anchorName === hash.replace('#', '');
  }

  render() {
    return (
      <ui-slide>
        {this.body.anchorName && (
          <ui-cms-anchor
            body={{
              anchorName: this.body.anchorName,
            }}
          ></ui-cms-anchor>
        )}
        <slot></slot>
      </ui-slide>
    );
  }
}
